import React from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';

const SubmitRequest: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="p-4">
        <div className="card bg-white rounded-sm p-4 border border-slate-300">
          <h2 className="text-lg font-bold text-slate-800 mb-4">ثبت درخواست</h2>
          <p className="text-slate-600 mb-4">
            در این بخش می‌توانید انواع درخواست‌های خود را ثبت کنید.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SubmitRequest;
